import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import '../../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../../api/brokerGroupApi";
import { ContextNotification, severitys } from "../../../App";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FileInput from "../../../Components/FileInput";
import CustomConfirmationDialog from "../../../Components/CustomConfirmationDialog";

const AddFlightFile = () => {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setOpen } = useContext(ContextNotification);
  const [fileForm, setFileForm] = useState(new FormData());
  const [hasFile, setHasFile] = useState(false);
  const [showOutput, setShowOutput] = useState(false);
const [outputMessage,setOutputMessage]=useState('');
const[openConfirm,setOpenConfirm]=useState(false);
  const customization = useSelector((state) => state.customization);
  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({

    resolver: yupResolver(schema),
  });

  const resetForm = () => {
    fileForm.delete('FormFile');
    setHasFile(false);
    setOpenConfirm(false);
   
  }
  const refreshform = () => {
    const fileinput = fileForm.get('FormFile')
    if (fileinput)
      setHasFile(true);
    else
      setHasFile(false);
        setOpenConfirm(false);
  }
  const onSubmit = (data) => {
    const fileinput = fileForm.get('FormFile')
    if (fileinput) {
      setSubmitLoading(true);
      brokerGroupApi.AddFlightFile(fileinput).then(res => {
        if (res.status === 200) {
          setOpen({ IsEnable: true, Message: 'فایل با موفقیت ثبت شد', severity: severitys.success });
          resetForm();
        }
        else {
          setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
        }

      }).catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { setSubmitLoading(false) });
    }
    else {
      setOpen({ IsEnable: true, Message: 'فایلی انتخاب نشده است', severity: severitys.error });
    }

  }
  const SincFlightInfo = () => {
   setValue("syncInfoMassage", '')
    setShowOutput(false);
    setLoading(true);
    brokerGroupApi.SyncFlightInfoFromTblFlight().then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: 'اطلاعات پرواز با موفقیت به روز رسانی شد', severity: severitys.success });
        if (res.data.data) {
              var output='';
              res.data.data.map(element => {
                output=output+element +'\n';
              });
              
              if(output.trim()!=='')
              {
       setOutputMessage(output);
          setShowOutput(true);
              }
   
        }

      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
      }

    })
      .catch(err => {

        if (err.response && err.response.data) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
        }
        else if (err.response && err.response.data && err.response.data.errors) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
        }
        else if (err.message) {
          setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
        }

      }).finally(() => { 
        setLoading(false);
        setOpenConfirm(false); });

  }
  return (
    <>
      <ThemeProvider theme={customtheme(customization)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2} >
            بارگذاری فایل پرواز      </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>

            <Grid container spacing={1}>
              <Grid item size={{ xs: 3, sm: 3, md: 3, lg: 1, xl: 1 }}>
                <FileInput formData={fileForm} refreshGrid={refreshform} />
              </Grid>
              <Grid item md={1} xs={4}>
                <Button type="submit" disabled={(submitLoading) || !(hasFile)} variant="contained" color="primary" fullWidth  >
                  <BeatLoading loading={submitLoading} color={"#e65100"} /> ثبت فایل </Button>
              </Grid>
              <Grid item md={1.5} xs={5}>
                <Button disabled={(loading)} variant="contained" color="primary" fullWidth
                  onClick={() => { setOpenConfirm(true) }} >
                  <BeatLoading loading={loading} color={"#e65100"} /> بروزرسانی اطلاعات پرواز </Button>

              </Grid>
            </Grid>
          <CustomConfirmationDialog
             open={openConfirm}
             message={'آیا از بروزرسانی اطلاعات پرواز با آخرین فایل ارسال شده اطمینان دارید؟'}
              handleClose={() => setOpenConfirm(false)}
              ActFunction={SincFlightInfo}>
          </CustomConfirmationDialog>
          </form>
        </RtlProvider>
         {showOutput &&
           <div dir="rtl">
              <TextField value={outputMessage}  multiline variant="filled" disabled fullWidth  />
            </div>} 
      </ThemeProvider>
    </>
  )

}
export default AddFlightFile